export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-bing-98f362ee72583ee245cb69002386b393.svg";